import { baseHelpdeskApi } from "@/config/http-helpdesk";
import { AxiosRequestConfig } from "axios";
import {
  AssistantBootstrapResponse,
  AssistantClientEventRequest,
  AssistantFeedbackRequest,
  AssistantGlobalResponse,
  AssistantMessageRequest,
  AssistantMessageResponse,
} from "@/types/assistant/Assistant";

const silentRequestConfig: AxiosRequestConfig & { silent: boolean } = {
  silent: true,
};

class AssistantDataService {
  bootstrap(language?: string | null): Promise<{
    data: AssistantGlobalResponse<AssistantBootstrapResponse>;
  }> {
    return baseHelpdeskApi.get("/assistant/bootstrap", {
      ...silentRequestConfig,
      params: language ? { language } : undefined,
    });
  }

  message(
    payload: AssistantMessageRequest
  ): Promise<{ data: AssistantGlobalResponse<AssistantMessageResponse> }> {
    return baseHelpdeskApi.post(
      "/assistant/message",
      payload,
      silentRequestConfig
    );
  }

  feedback(
    payload: AssistantFeedbackRequest
  ): Promise<{ data: AssistantGlobalResponse<void> }> {
    return baseHelpdeskApi.post(
      "/assistant/feedback",
      payload,
      silentRequestConfig
    );
  }

  event(
    payload: AssistantClientEventRequest
  ): Promise<{ data: AssistantGlobalResponse<void> }> {
    return baseHelpdeskApi.post(
      "/assistant/event",
      payload,
      silentRequestConfig
    );
  }
}

export default new AssistantDataService();
